import * as betHistoryConstants from './betHistoryConstants';

export const BASE_PATH = window.BASE_PATH;
export const CDN_URL_TMP = 'https://d29bnxtiec58nc.cloudfront.net';

export { betHistoryConstants };

export const currencySymbols = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  B9C: 'B9C',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BRL: 'R$',
  BSD: '$',
  BTC: 'BTC',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHF: 'CHF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'ETH',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'LTC',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: 'N$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYU: '$U',
  UZS: "so'm",
  VEF: 'Bs',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XRP: 'XRP',
  YER: '﷼',
  ZAR: 'R',
  ZWD: 'Z$',
};

export const paymentTypes = {
  BONUS_ACTIVATE: 'BONUS_ACTIVATE',
  BONUS_COMPLETE: 'BONUS_COMPLETE',
  BONUS_DEACTIVATE: 'BONUS_DEACTIVATE',
  CASHBACK_CREATE: 'CASHBACK_CREATE',
  CORRECTION_BALANCE_DEPOSIT: 'CORRECTION_BALANCE_DEPOSIT',
  CORRECTION_BALANCE_WITHDRAWAL: 'CORRECTION_BALANCE_WITHDRAWAL',
  CORRECTION_BONUS_DEPOSIT: 'CORRECTION_BONUS_DEPOSIT',
  CORRECTION_BONUS_WITHDRAWAL: 'CORRECTION_BONUS_WITHDRAWAL',
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
};

export const sportService = {
  ARCHIVED: 'ARCHIVED',
  LIVE: 'LIVE',
  PREMATCH: 'PREMATCH',
  UNSPECIFIED: 'UNSPECIFIED',
};

export const betStatuses = {
  CANCELLED: 'CANCELLED',
  CASH_OUT: 'CASH_OUT',
  LOSE: 'LOSE',
  UNSETTLED: 'UNSETTLED',
  VOID: 'VOID',
  WIN: 'WIN',
};

export const outcomeStatuses = {
  NOT_DEFINED: 'NOT_DEFINED',
};

const { CANCELLED, CASH_OUT, LOSE, UNSETTLED, VOID, WIN } = betStatuses;

export const betStatusesList = [UNSETTLED, LOSE, WIN, VOID, CANCELLED, CASH_OUT];

export const BONUS_CONFLICT_ERROR_CODES = [
  'IN_PROGRESS_BONUS_EXISTS',
  'MAX_NUMBER_OF_ACTIVE_BONUSES',
  'MAX_NUMBER_OF_ACTIVATED_BONUSES',
];

export const BONUS_CONFLICT_ERROR_MESSAGES = [
  'IN_PROGRESS_BONUS_EXISTS validation failed.',
  'MAX_NUMBER_OF_ACTIVE_BONUSES validation failed.',
  'MAX_NUMBER_OF_ACTIVATED_BONUSES validation failed.',
];

export const FREE_SPIN_LOAD_STATUSES = [
  'ACTIVATION_READY',
  'PENDING_ACTIVATION',
  'ACTIVATED',
  'USED',
  'DISABLED',
  'CANCELED',
  'EXPIRED',
];

export const bonusStatuses = {
  ACTIVATED: 'ACTIVATED',
  ACTIVATION_EXPIRED: 'ACTIVATION_EXPIRED',
  ACTIVATION_READY: 'ACTIVATION_READY',
  ACTIVE: 'ACTIVE',
  AVAILABLE: 'AVAILABLE',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  LOSE: 'LOSE',
  PENDING: 'PENDING',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  SPEND: 'SPEND',
  USED: 'USED',
  VOID: 'VOID',
  WIN: 'WIN',
};

export const FREEBET_STATUSES = {
  FREEBET_ACTIVATED: 'FREEBET_ACTIVATED',
  FREEBET_CANCELED: 'FREEBET_CANCELED',
  FREEBET_EXPIRED: 'FREEBET_EXPIRED',
  FREEBET_IN_PROGRESS: 'FREEBET_IN_PROGRESS',
  FREEBET_LOSE: 'FREEBET_LOSE',
  FREEBET_VOID: 'FREEBET_VOID',
  FREEBET_WIN: 'FREEBET_WIN',
};

export const FREESPIN_STATUS = {
  ACTIVATED: 'ACTIVATED',
  ACTIVATION_READY: 'ACTIVATION_READY',
  CANCELED: 'CANCELED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  USED: 'USED',
};

/** Template `freeSpinSubType` (client-freespin API). `REGULAR`: `createTime + timeToUse`. `DEPOSIT`: prefer BE `expirationTime`. */
export const FREE_SPIN_SUBTYPE = {
  DEPOSIT: 'DEPOSIT',
  REGULAR: 'REGULAR',
};

export const transactionStatuses = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  SUCCEED: 'SUCCEED',
  SUCCESS: 'SUCCESS',
};

export const readableBetStatuses = {
  CANCELLED: 'Return',
  CASH_OUT: 'Cashed Out',
  LOSE: 'Loss',
  UNSETTLED: 'Not settled',
  VOID: 'Void',
  WIN: 'Win',
};

export const betTypes = {
  MULTIPLE: 'MULTIPLE',
  SINGLE: 'SINGLE',
  SYSTEM: 'SYSTEM',
};

export const betSettingOptions = {
  DEFAULT: 'YES',
  DOWN: 'DOWN',
  NO: 'NO',
  UP: 'UP',
  YES: 'YES',
};

export const urlSeparator = '/';
export const amountOfSymbolsToStartSearch = 3;
export const querySymbol = '?q=';
export const topTournamentsRouteSportId = 'top-tournaments';
export const marketView = 'marketView';
export const marketViews = {
  atlas: 'atlas',
  fonbet: 'fonbet',
};

export const displayLayoutTypes = {
  '2way': true,
  '2way_param': true,
  '3way': true,
  '3way_param': true,
  '3way_total_param': true,

  Handicap: true,
  TENNIS_LEAD_AF: true,

  badminton_race_to: true,
  basketball_both_to_sx: true,
  basketball_race_to: true,
  basketball_to_score: true,
  handicap_3_way: true,
  ice_hockey_race_to: true,

  multiway: true,

  next_goal: true,
  soccer_1x2_total: true,

  soccer_correct_score: true,
  soccer_race_to: true,
  soccer_total_both_team_toscore: true,
  tennis_correct_score: true,

  tennis_game_deuce: true,
  tennis_game_score: true,
  tennis_game_winner: true,
  tennis_point_winner: true,
  tennis_race_to: true,
  tt_point_winner: true,
  tt_race_to: true,
  volleyball_race_to: true,
};

export const sportIds = {
  baseball: 48,
  basketball: 3,
  iceHockey: 18,
  soccer: 1,
  tableTennis: 7,
  tennis: 2,
  volleyball: 17,
};

export const periodTypeIds = {
  tennisGamePeriodId: 58,
};

export const OPERATION_STATUS_FAILED = 'FAILED';
export const OPERATION_STATUS_SUCCEED = 'SUCCEED';

// For some sports we show word 'sets' instead of 'score'
export const SPORT_IDS_WITH_SETS = [2];
// For some sports we show word 'points' instead of period description from backend
export const SPORT_IDS_WITH_POINTS = [2, 7];
// For some sports we shouldn't show period info
export const SPORT_IDS_WITHOUT_PERIOD_VIEW = [];

export const marketGroupTypes = {
  betGroup: 'bet_group',
  marketGroup: 'market_group',
};

export const DEFAULT_URL_SPORT_NAME = 'Sport';
export const DEFAULT_URL_CATEGORY_NAME = 'Category';
export const DEFAULT_URL_TOURNAMENT_NAME = 'Tournament';
export const DEFAULT_URL_EVENT_NAME = 'Event';

export const MAX_TIMESTAMP = 1800000000000;
export const MIN_TIMESTAMP = 0;
export const betAmountMaxValue = 9223e13;

export const millisecondsInDay = 86400000;

export const languageTypeFlag = 'flag';
export const languageTypeISO = 'iso';

export const PLATFORM_TYPES = {
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
  MULTIPLATFORM: 'MULTIPLATFORM',
};

export const SPORTSBOOK_UNDER_TECHNICAL_MAINTENANCE = ['sportsbook', 'live', 'results'];

export const bonusTypes = {
  DEPOSIT: 'DEPOSIT',
  DEPOSIT_FREESPIN: 'DEPOSIT_FREESPIN',
  FREESPIN: 'FREESPIN',
  NO_DEPOSIT: 'NO_DEPOSIT',
  RELOAD_DEPOSIT: 'RELOAD_DEPOSIT',
  RELOAD_NO_DEPOSIT: 'RELOAD_NO_DEPOSIT',
};

export const SECOND = 1000;
export const MIN = 60 * 1000;
export const HOUR = 60 * MIN;
export const DAY = 24 * HOUR;

export const DEFAULT_LANG = 'ENG';

export const SANALBANK_BANKS = {
  11: 'Garanti Bankası',
  12: 'İş Bank',
  13: 'Ziraat Bankası',
  14: 'Akbank',
  15: 'Yapi kredi Bankası',
  16: 'Finansbank - Enpara',
  17: 'Vakifbank',
  18: 'TEB',
  19: 'Denizbank',
  20: 'Halkbank',
  21: 'ING Bank',
  22: 'Şekerbank',
  23: 'Kuveyt Türk',
  24: 'Al Baraka',
  25: 'Odeabank',
  26: 'Alternatif Bank',
  27: 'Anadolubank',
  28: 'Burgan Bank',
  29: 'Fibabanka',
  30: 'HSBC',
  31: 'ICBC',
  32: 'Turkish Bank',
  33: 'Turkiye Finans',
  34: 'Ziraat Katilim',
  35: 'Vakif Katilim',
  36: 'Emlak Katilim',
  67: 'PTT',
  68: 'Aktif Bank',
  71: 'Fast - Other',
};

export const PIX_TYPES = {
  CPF: 'cpf',
  EMAIL: 'email',
  EVP: 'evp',
  PHONE: 'phone',
};

export const PIX_TYPES_VALUES_MAX_LENGTH = {
  EMAIL: 128,
  EVP: 128,
  PHONE: 14,
};

export const CLABE_WITHDRAWAL_LENGTH = 18;

export const POPUP_SIGN_UP_DELAY_STORAGE_KEYS = {
  BONUSES: 'popupSignUpBonuses',
  NEXT_SHOW: 'popupSignUpDelayNextShow',
  TIMEOUT_ID: 'popupSignUpDelayTimeoutId',
};

export const DATA_LAYER_STORAGE_KEYS = {
  CASHBOX_DEPOSIT_CLICKED: 'cashboxDepositClicked',
  CASHBOX_OPENED: 'cashboxOpened',
  LEAVING_REGISTRATION_POPUP_CLOSED: 'leavingRegistrationPopupClosed',
  LEAVING_REGISTRATION_POPUP_CTA_CLICKED: 'leavingRegistrationPopupCtaCliClicked',
  LEAVING_REGISTRATION_POPUP_SHOWN: 'leavingRegistrationPopupShown',
  QUICK_DEPOSIT_BUTTON_CLICKED: 'quickDepositButtonClicked',
  REGISTRATION_BUTTON_CLICKED: 'registrationButtonClicked',
  REGISTRATION_STEP: step => `registrationStep${step}`,
};

export const SPORT_IDS_WITH_DETAILED_SCORE = [2, 3, 6, 7, 17, 34];

export const MATCH_WINNER_SPORT_IDS = [
  346, 396, 772, 1013, 2, 48, 156, 2875, 2920, 1416, 2659, 2680, 3034, 2970, 1200, 1216, 2983, 3056,
  3055, 5551, 1521, 1750, 1772, 1770, 1821, 3321, 3330, 3342, 2801, 2849, 1714, 2990, 3033, 5569,
  2969, 10821, 10822, 5549, 2000, 2017, 1600, 1619, 10799, 3065, 3104, 3103, 2555, 2578, 2576, 2610,
  1900, 1914, 2100, 2116, 2149, 2962, 11029, 2959, 5533, 2424, 2460, 3052, 5576, 10802, 10927,
];

export const POPUP_MESSAGES_STORAGE_KEY = 'isMessagePopupShowed';
export const HIDE_FREEBET_FOR_CURRENT_SESSION = 'HideFreebetForCurrentSession';

export const CXFROM_STORAGE_KEY = 'cxfrom';
export const BTAG_STORAGE_KEY = 'btag';

export const OAUTH_FLOW_TYPE_STORAGE_KEY = 'oauth_flow_type';

export const OAUTH_FLOW_TYPES = {
  SIGNIN: 'signin',
  SIGNUP: 'signup',
  SIGNUP_MULTISTEP: 'signup_multistep',
};

export const KYC_AUTO_RUN_KEY = 'kycAutoRun';

export const SITE_OPENING_DISABLED_POPUP_STORAGE_KEY = 'siteOpeningPopup';
export const SIGN_IN_POPUP_STORAGE_KEY = 'signinMultiPopup';
export const SIGN_UP_POPUP_STORAGE_KEY = 'signupMultiPopup';

export const SIGN_IN_REDIRECT_URL_QUERY_KEY = 'withRedirect';
export const ADULT_COOKIE_NAME = 'adult_confirmation';
export const REGISTRATION_FLOW_ACTIVE_STORAGE_KEY = 'registrationFlowActive';

export const TERMINAL_STORAGE_KEY = 'terminalKey';

export const ERRORS_MAP = {
  NOT_FOUND: 'book_a_bet_error_invalid_id',
};

export const userVerificationStatuses = {
  NEW: 'NEW',
  UNCONFIRMED: 'UNCONFIRMED',
};

export const searchQuerySymbol = 'q';
export const MIN_SEARCH_STRING_LENGTH = 3;
export const SEARCH_DEBOUNCE_TIMER = 300;

/* eslint-disable */
export const DIRECTA_BANKS = {
  16: 'first_bank_nigeria_plc',
  30: 'heritage_bank',
  32: 'union_bank_nigeria_plc',
  33: 'united_bank_africa_plc',
  35: 'wema_bank_plc',
  44: 'access_bank',
  50: 'ecobank_nigeria',
  57: 'zenith_bank',
  58: 'guaranty_trust_bank_plc',
  70: 'fidelity_bank_plc',
  82: 'keystone_bank_ltd',
  214: 'first_city_monument_bank',
  215: 'unity_bank_plc',
  232: 'sterling_bank_plc',
  301: 'jaiz_bank',
};
/* eslint-enable */

export const WIDGETS_TYPES = {
  SCORE_BOARD: 'SCORE_BOARD',
  STATISTIC: 'STATISTIC',
  VIDEO_STREAM: 'VIDEO_STREAM',
};

export const WIDGETS_INDEXES = {
  SCORE_BOARD: 1,
  STATISTIC: 3,
  VIDEO_STREAM: 2,
};

export const ADULT_POPUP_STATE = {
  FORBIDDEN: 0,
  GRANTED: 1,
  SELECTION: 2,
};

export const PROMO_CODES_ERRORS = {
  DEFAULT: 'promocode_not_exist',
  PROMO_CODE_ACTIVATIONS_EXCEEDED: 'promocode_expired',
  PROMO_CODE_ACTIVATIONS_PER_CLIENT_EXCEEDED: 'promocode_exhausted',
  PROMO_CODE_ALREADY_FINISHED: 'promocode_expired',
  PROMO_CODE_ARCHIVED: 'promocode_expired',
  PROMO_CODE_NOT_FOUND: 'promocode_not_exist',
  PROMO_CODE_NOT_STARTED_YET: 'promocode_not_active_yet',
};

export const ALWAYS_ALLOWED_PAGES = ['/login', '/signup', '/page/terms-and-conditions'];

export const LEAVE_SIGNUP_NOTIFICATION_ID = 'leaveSignup';

export const ACCOUNT_NUMBERS_POPUP_TYPES = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
};

export const ACCOUNT_STATUSES = {
  PARTIALLY_REGISTERED: 'PARTIALLY_REGISTERED',
};

export const realityCheckVariants = [
  {
    label: '1 min',
    value: 'MINUTE_1',
  },
  {
    label: '5 min',
    value: 'MINUTE_5',
  },
  {
    label: '10 min',
    value: 'MINUTE_10',
  },
  {
    label: '20 min',
    value: 'MINUTE_20',
  },
  {
    label: '30 min',
    value: 'MINUTE_30',
  },
  {
    label: '1 hour',
    value: 'HOUR_1',
  },
  {
    label: '2 hour',
    value: 'HOUR_2',
  },
  {
    label: '4 hour',
    value: 'HOUR_4',
  },
  {
    label: '6 hour',
    value: 'HOUR_6',
  },
  {
    label: 'Do Not Remind',
    value: 'NEVER',
  },
];

export const REDIRECT_DATA_AFTER_DEPOSIT = 'redirectDataAfterDeposit';
export const DEPOSIT_FAILED = 'DEPOSIT_FAILED';

export const COOKIES_ACCEPTED_EVENT = 'cookies:accepted';

export const QUICK_DEPOSIT_POPUP_TITLE_TYPE = {
  INSUFFICIENT: 'insufficient',
  QUICK_DEPOSIT: 'quickDeposit',
};

export const POSTHOG_EVENTS = {
  ALTERNATIVE_PAYMENT_METHOD_POP_UP: 'alternative_payment_method_pop-up',
  DEPOSIT_LOADER_SHOWN: 'deposit_loader_shown',
  DEPOSIT_REDIRECT_SUCCESS: 'deposit_redirect_success',
  DEP_POP_UP_SHOWN: 'dep_pop_up_shown',
  QUICK_DEP_POP_UP_SHOWN: 'quick_dep_pop_up_shown',
  REGISTRATION: 'registration',
};

export const POSTHOG_CTA = {
  BACK_TO_PREV_STEP: 'back_to_prev_step',
  BACK_TO_REG: 'back_to_reg',
  DEPOSIT: 'deposit',
  NEXT_STEP: 'next_step',
};

export const POSTHOG_SESSION_KEYS = {
  DEPOSIT_PAGE_REFER: 'posthog_deposit_page_refer',
  LAST_DEPOSIT_PAGE_REFER: 'posthog_last_deposit_page_refer',
};

export const POSTHOG_PAGE_REFER = {
  ALTERNATIVE_PAYMENT_METHOD_POP_UP: 'alternative payment_method pop-up',
  BONUSES: '/bonuses',
  CASINO: '/casino',
  PROMO: '/promo',
};

export const CASINO_PRODUCT_TYPE = 'CASINO';
export const SPORTSBOOK_PRODUCT_TYPE = 'SPORTSBOOK';

export const SPORTSBOOK_PROVIDERS = {
  ALTENAR: 'Altenar',
};

export const OAUTH_AUTH_TOKEN_COOKIE = 'x-auth-token';
export const OAUTH_REGISTER_INFO_COOKIE = 'x-register-info';
export const OAUTH_REGISTER_INFO_TOKEN_STORAGE_KEY = 'oauth_registration_token';

export const {
  ACTIVATED,
  ACTIVATION_EXPIRED,
  ACTIVATION_READY,
  ACTIVE,
  CANCELED,
  COMPLETED,
  DISABLED,
  EXPIRED,
  IN_PROGRESS,
  PENDING,
  PENDING_ACTIVATION,
  SPEND,
  USED,
} = bonusStatuses;

export const statusOrder = {
  [ACTIVATED]: 2,
  [ACTIVATION_READY]: 4,
  [ACTIVE]: 5,
  [CANCELED]: 11,
  [COMPLETED]: 7,
  [DISABLED]: 12,
  [EXPIRED]: 10,
  [IN_PROGRESS]: 1,
  [PENDING]: 6,
  [PENDING_ACTIVATION]: 3,
  [SPEND]: 9,
  [USED]: 8,
};

export const freebetStatusOrder = {
  [FREEBET_STATUSES.FREEBET_ACTIVATED]: 2,
  [FREEBET_STATUSES.FREEBET_CANCELED]: 6,
  [FREEBET_STATUSES.FREEBET_EXPIRED]: 5,
  [FREEBET_STATUSES.FREEBET_IN_PROGRESS]: 1,
  [FREEBET_STATUSES.FREEBET_LOSE]: 4,
  [FREEBET_STATUSES.FREEBET_VOID]: 7,
  [FREEBET_STATUSES.FREEBET_WIN]: 3,
};

export const PASSWORD_FIELDS_NAMES = {
  PASSWORD: 'PASSWORD',
  PASSWORD_CONFIRMATION: 'PASSWORD_CONFIRMATION',
};
